import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// AttentionPanel (fase 3 do redesign, §11/§26) — substitui a antiga pilha
// de KpiCards genéricos do Dashboard por uma lista única, priorizada, do
// que precisa da atenção do dono do negócio agora. Um item só some da
// lista quando a contagem é 0 (não mostra "0" cinza sem função — se não
// precisa de atenção, não ocupa espaço aqui).
export function AttentionPanel({ items = [], emptyLabel = 'Tudo em dia por aqui.' }) {
  const visiveis = items.filter((i) => i.count > 0);
  if (visiveis.length === 0) {
    return (
      <div className="crm-attention-empty">
        <span className="crm-attention-empty-icon"><FontAwesomeIcon icon={faCheck} /></span>
        <span>{emptyLabel}</span>
      </div>
    );
  }
  return (
    <div className="crm-attention-list">
      {visiveis.map((item) => (
        <button key={item.id} className="crm-attention-item" onClick={item.onClick}>
          <span className={`crm-attention-dot crm-attention-dot-${item.tone || 'warning'}`} />
          <span className="crm-attention-label">{item.label}</span>
          <span className="crm-attention-count">{item.count}</span>
          <FontAwesomeIcon icon={faChevronRight} className="crm-attention-chevron" />
        </button>
      ))}
    </div>
  );
}

export default AttentionPanel;
